import * as React from "react";

/**
 * Rate limits a callback function to the animation frame rate
 */

type Callback = () => void;

export const useAnimationFrame = () => {
	const callbackRef = React.useRef<Callback>();
	const isLooping = React.useRef(false);

	const loop = () => {
		if (callbackRef.current) {
			isLooping.current = true;
			callbackRef.current();
			callbackRef.current = undefined;
			requestAnimationFrame(loop);
		} else {
			isLooping.current = false;
		}
	};

	return (callback: Callback) => {
		callbackRef.current = callback;
		if (!isLooping.current) {
			requestAnimationFrame(loop);
		}
	};
};
